import React from 'react';
import { connect } from 'react-redux';

import { renderImage } from '../../components/image/image';
import { getTranslation } from '../../translation/translation';

import './errorPage.scss';

interface ErrorPageProps {
    textErrorTitle: string;
    textErrorSubtitle: string;
    textErrorButton: string;

    onErrorButtonClick: () => void;
}

class ErrorPage extends React.Component<ErrorPageProps> {
    public render() {
        return (
            <div className='error-page'>
                {renderImage('/seic_website/assets/image/illustration-03.png', 'error-image')}
                <h2 className='error-title'>{this.props.textErrorTitle}</h2>
                <div className='error-subtitle'>{this.props.textErrorSubtitle}</div>
                <button className='error-button' onClick={this.props.onErrorButtonClick}>{this.props.textErrorButton}</button>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        textErrorTitle: getTranslation(state, 14),
        textErrorSubtitle: getTranslation(state, 15),
        textErrorButton: getTranslation(state, 16),
    };
}

export default connect(mapStateToProps)(ErrorPage);
export const ErrorPageComponent = ErrorPage;
